/**
 * Fetch a specific id of a resource.
 * This action will trigger the normal flow of sagas to continu
 */
export const fetchIdFromResource = (payload) => {
    if (!payload) {
        throw new Error('A payload was not defined.');
    }

    if (!payload.resource) {
        throw new Error('Resource was not defined to the payload.');
    }

    if (!payload.id) {
        throw new Error('Id was not defined to the payload.');
    }

    if (!payload.type) {
        throw new Error('Type was not defined to the payload.');
    }

    const data = payload;

    const label = data.type.toUpperCase();
    const type = `FETCH_${ label }` || 'NO_RESOURCE_SET';

    delete data.type;

    return {
        type: type,
        payload: data,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/reference/fetchReference.js